export const healthCheckPhase = Object.freeze({
  HEALTH_CHECK: 'HEALTH_CHECK',
  CLOSE_COUNTERS: 'CLOSE_COUNTERS',
  EOD: 'EOD'
});
